import { BaseButton } from '@/components/common/base-button';
import PlaceHolder from '@/components/icons/shop/PlaceHolder';
import type { PoiContent } from '@/services/dto';
import { useConfigStore } from '@/stores';
import { getPoiListImageUrlFromContent } from '@/utils/poi/poiImage';
import clsx from 'clsx';
import styles from './styles.module.scss';

type Props = {
    poiList: PoiContent[];
    selectedPoiId?: string;
    onSelectPoi?: (poi: PoiContent) => void;
    tabOrders?: number[];
};

export const FloorGuidePoiContentCarousel = ({ poiList, selectedPoiId, onSelectPoi, tabOrders = [] }: Props) => {
    const language = useConfigStore((state) => state.config.ui.language);

    if (!Array.isArray(poiList) || poiList.length < 2) {
        return null;
    }

    return (
        <div className={clsx(styles['floor-guide-poi-content-carousel'], 'scrollbar-hide')}>
            {poiList.map((poi, index) => {
                const isSelected = selectedPoiId === poi.id;
                const imageUrl = getPoiListImageUrlFromContent(poi, language);
                const poiName = poi.name?.[language] || poi.name?.['ko'] || '';
                const tabOrder = tabOrders[index];

                return (
                    <BaseButton
                        key={poi.id}
                        data-modal-region
                        tabIndex={tabOrder}
                        data-modal-region-order={tabOrder}
                        data-interactive
                        onClick={() => onSelectPoi?.(poi)}
                        className={clsx(styles['floor-guide-poi-content-carousel__item'], 'focus-border', {
                            [styles['floor-guide-poi-content-carousel__item--selected']]: isSelected,
                        })}
                        aria-label={poiName}
                    >
                        <div className={styles['floor-guide-poi-content-carousel__image']}>
                            {imageUrl ? (
                                <img src={imageUrl} alt={poiName} />
                            ) : (
                                <PlaceHolder />
                            )}
                        </div>
                        <div
                            className={clsx(styles['floor-guide-poi-content-carousel__name'], {
                                [styles['floor-guide-poi-content-carousel__name--selected']]: isSelected,
                            })}
                        >
                            {poiName}
                        </div>
                        {!isSelected && <div className={styles['floor-guide-poi-content-carousel__mask']} aria-hidden />}
                    </BaseButton>
                );
            })}
        </div>
    );
};
